<template>
  <div>
    <PageHeader title="Lançamento novo Projeto Astec" />
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div class="card" v-if="!loading">
      <div class="card-body">
        <div class="row d-flex justify-content-between">
          <div class="col-md-10">
            <b-card-title>
              <h5 class="card-title mb-3">
                Informações do Novo Projeto a-
                <span class="badge badge-pill font-size-15 badge-soft-info">
                  ELABORADO
                </span>
                <span v-if="sqProjetoVar"> - {{ sqProjetoVar }}</span>
              </h5>
            </b-card-title>
          </div>
        </div>

        <div class="row d-flex mb-1">
          <div class="col-md-3">
            <b-form-group label="Cooperado" :state="state('selecaoCooperado')">
              <multiselect
                v-model="selecaoCooperado"
                :options="cooperadoLkp"
                label="name"
                track-by="value"
                placeholder="Selecione"
                :allowEmpty="false"
                :taggable="false"
                select-label=""
                @input="carregarClienteRural"
                invalid-feedback="Campo obrigatório"
                :disabled="disabledCampos"
              >
                <span slot="noOptions">Nenhum Cooperado disponível</span>
              </multiselect>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group
              label="Cliente Rural"
              :state="state('selecaoClienteRural')"
            >
              <multiselect
                v-model="selecaoClienteRural"
                :options="clienteRuralLkp"
                label="name"
                track-by="value"
                placeholder="Selecione"
                select-label=""
                invalid-feedback="Campo obrigatório"
                :disabled="disabledCampos"
                :loading="loadingClienteRural"
              >
                <span slot="noOptions">Nenhum Cliente Rural disponível</span>
              </multiselect>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group
              label="CPF/CNPJ"
              :state="state('selecaoClienteRural')"
            >
              <multiselect
                v-model="selecaoClienteRural"
                :options="clienteRuralLkp"
                label="cpfCnpj"
                track-by="name"
                placeholder="Selecione"
                select-label=""
                invalid-feedback="Campo obrigatório"
                :disabled="disabledCampos"
                :loading="loadingClienteRural"
              >
                <span slot="noOptions">Nenhum CPF/CNPJ disponível</span>
              </multiselect>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group
              label="N° Projeto"
              invalid-feedback="Campo obrigatório"
            >
              <b-form-input
                v-model="numeroProjeto"
                v-mask="'########'"
                type="text"
                :maxlength="8"
                :state="state('numeroProjeto')"
                :disabled="disabledCampos"
              />
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group
              label="Data do Projeto"
              :state="state('dataProjeto')"
              invalid-feedback="Campo obrigatório"
            >
              <date-picker
                v-model="dataProjeto"
                value-type="YYYY-MM-DD HH:mm:ss"
                format="DD/MM/YYYY"
                append-to-body
                :disabled="disabledCampos"
                :disabled-date="disableDatasFuturas"
                @input="disableDatasPosteriores()"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row d-flex mb-1">
          <div class="col-md-3">
            <b-form-group
              label="Instituição Financeira"
              :state="state('selecaoInstituicaoFinanceira')"
              invalid-feedback="Campo obrigatório"
            >
              <multiselect
                v-model="selecaoInstituicaoFinanceira"
                :loading="loadingInstFinanceira"
                :disabled="disabledCampos"
                :options="instituicaoFinanceiraLkp"
                label="name"
                track-by="name"
                placeholder="Selecione"
                select-label=""
                @input="carregarAgencia"
              />
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group
              label="Agencia"
              :state="state('selecaoAgencia')"
              invalid-feedback="Campo obrigatório"
            >
              <multiselect
                v-model="selecaoAgencia"
                :loading="loadingAgencia"
                :disabled="disabledCampos"
                :options="instituicaoAgenciaLkp"
                label="name"
                track-by="name"
                placeholder="Selecione"
                select-label=""
              />
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group
              label="Município - UF"
              :state="state('selecaoMunicipio')"
              invalid-feedback="Campo obrigatório"
            >
              <multiselect
                v-model="selecaoMunicipio"
                :disabled="disabledCampos"
                :options="selecaoMunicipioLkp"
                label="name"
                track-by="name"
                placeholder="Selecione"
                select-label=""
              />
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group
              label="Linha de Crédito"
              :state="state('selecaoLinhaCredito')"
              invalid-feedback="Campo obrigatório"
            >
              <multiselect
                v-model="selecaoLinhaCredito"
                :options="linhaCreditoLkp"
                label="name"
                track-by="name"
                placeholder="Selecione"
                select-label=""
                :disabled="disabledCampos"
              >
                <span slot="noOptions"
                  >Nenhuma Linha de Crédito disponível</span
                >
              </multiselect>
            </b-form-group>
          </div>
        </div>
        <div class="row d-flex mb-1">
          <div class="col-md-3">
            <b-form-group
              label="Safra"
              :state="state('selecaoSafra')"
              invalid-feedback="Campo obrigatório"
            >
              <multiselect
                v-model="selecaoSafra"
                :disabled="disabledCampos"
                :options="selecaoSafraLkp"
                label="name"
                track-by="name"
                placeholder="Selecione"
                select-label=""
                @input="carregarItemAgropecuario"
              />
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group
              label="Tipo de Projeto"
              :state="state('selecaoTipoProjeto')"
              invalid-feedback="Campo obrigatório"
            >
              <multiselect
                v-model="selecaoTipoProjeto"
                :options="tipoProjetoLkp"
                label="name"
                track-by="name"
                placeholder="Selecione"
                select-label=""
                @input="carregarItemAgropecuario"
                :disabled="disabledCampos"
              >
                <span slot="noOptions">Nenhum Tipo de Projeto disponível</span>
              </multiselect>
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group
              label="Item Agropecuário"
              :state="state('selecaoItemAgropecuario')"
              invalid-feedback="Campo obrigatório"
            >
              <multiselect
                v-model="selecaoItemAgropecuario"
                :disabled="disabledCampos"
                :options="itemAgropecuarioLkp"
                :loading="loadingItemAgropecuario"
                label="name"
                track-by="name"
                placeholder="Selecione"
                select-label=""
              />
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group
              label="Área (ha)"
              invalid-feedback="Campo obrigatório"
              :state="state('areaHa')"
            >
              <money
                v-model="areaHa"
                v-bind="area"
                class="form-control"
                :state="state('areaHa')"
                :disabled="disabledCampos"
              >
              </money>
            </b-form-group>
          </div>
        </div>
        <div class="row d-flex mb-1">
          <div class="col-md-3">
            <b-form-group
              label="Modalidade do Seguro"
              :state="state('selecaoModalidadeSeguro')"
              invalid-feedback="Campo obrigatório"
            >
              <multiselect
                v-model="selecaoModalidadeSeguro"
                :disabled="disabledCampos"
                :options="selecaoModalidadeSeguroLkp"
                label="name"
                track-by="name"
                placeholder="Selecione"
                select-label=""
              />
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group
              label="Valor Orçado"
              :state="state('vlOrcado')"
              invalid-feedback="Campo obrigatório"
            >
              <money
                v-model="vlOrcado"
                v-bind="money"
                class="form-control"
                :state="state('vlOrcado')"
                :disabled="disabledCampos"
              >
              </money>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group label="% Astec" invalid-feedback="Campo obrigatório">
              <input
                v-model.lazy="perAstec"
                v-money="porcentagem"
                class="form-control"
                :maxlength="8"
                :state="state('perAstec')"
                :disabled="disabledCampos"
              />
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group
              label="Valor Astec"
              :state="state('vlAstec')"
              invalid-feedback="Campo obrigatório"
            >
              <money
                v-model="vlAstec"
                v-bind="money"
                class="form-control money-mask"
                :disabled="disabledCampos"
              >
              </money>
            </b-form-group>
          </div>
        </div>
        <div class="row d-flex mb-3">
          <div class="col-md-3">
            <b-form-group
              label="N° Operação"
              invalid-feedback="Campo obrigatório"
            >
              <b-form-input
                v-model="nOperacao"
                type="text"
                :disabled="disabledCampos"
              />
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group
              label="Data Venc. Boleto"
              invalid-feedback="Campo obrigatório"
            >
              <date-picker
                v-model="dataVencBoleto"
                value-type="YYYY-MM-DD HH:mm:ss"
                format="DD/MM/YYYY"
                append-to-body
                :disabled="disabledCampos"
                :disabled-date="disableDatasPosteriores"
              />
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group
              label="Valor Liberado"
              invalid-feedback="Campo obrigatório"
            >
              <money
                v-model="vlLiberado"
                v-bind="money"
                class="form-control"
                :disabled="true"
              >
              </money>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group
              label="Data Crédito"
              invalid-feedback="Campo obrigatório"
            >
              <date-picker
                v-model="dataCredito"
                value-type="YYYY-MM-DD HH:mm:ss"
                format="DD/MM/YYYY"
                append-to-body
                :disabled="true"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row d-flex justify-content-between mb-1 align-items-center">
          <div class="col-md-6 d-flex justify-content-start align-items-center">
            <b-button variant="light" size="lg" class="me-md-1 mb-2 mb-md-0">
              <i class="mdi mdi-cash-remove"></i>
            </b-button>
            <b-button variant="light" size="lg" class="me-md-1 mb-2 mb-md-0">
              <img
                :src="require('@/assets/images/pix-brands-solid.svg')"
                alt="Pix Brands"
                height="18"
              />
            </b-button>
            <b-button variant="light" size="lg">
              <i class="mdi mdi-cash-refund"></i>
            </b-button>
          </div>
          <div class="col-md-6  d-flex justify-content-end align-items-center">
            <b-button
              variant="secondary"
              size="md"
              class="me-md-1 mb-2 mb-md-0"
              @click="voltar"
              data-tooltip="Voltar"
              data-tooltip-location="bottom"
            >
              <i class="mdi mdi-arrow-left-circle"></i>
              Voltar
            </b-button>
            <b-button
              variant="success"
              size="md"
              @click="insertProjeto"
              :disabled="loadingSalvar || disabledCampos"
              data-tooltip="Salvar"
              data-tooltip-location="bottom"
            >
              <i class="mdi mdi-content-save"></i>
              salvar
              <b-spinner
                variant="primary"
                small
                class="ms-2"
                v-if="loadingSalvar"
              ></b-spinner>
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <div class="card" v-if="!loading">
      <div class="card-body">
        <div class="row d-flex justify-content-between">
          <div class="col-md-12">
            <h4 class="fs-bold">O que falta incluir?</h4>
            <div>
              <p
                v-for="requisitoSugestao in requisitoSugestao"
                :key="requisitoSugestao"
              >
                *{{ requisitoSugestao }}*
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";
import { Money } from "v-money";
import Swal from "sweetalert2";
import { required, minValue } from "vuelidate/lib/validators";

export default {
  mixins: [clienteRuralMixin],
  components: { Multiselect, PageHeader, Money },
  data() {
    return {
      statusProjeto: "",
      selecaoCooperado: null,
      cooperadoLkp: [],
      clienteRuralLkp: [],
      selecaoClienteRural: null,
      selecaocpfCnpj: "",
      cpfCnpjInvalido: false,
      numeroProjeto: "",
      dataProjeto: null,
      linhaCreditoLkp: [],
      selecaoLinhaCredito: null,
      selecaoTipoProjeto: null,
      tipoProjetoLkp: [],
      selecaoModalidadeSeguro: null,
      selecaoModalidadeSeguroLkp: [],
      StatusLkp: [],
      selecaoStatus: null,
      itemAgropecuarioLkp: [],
      selecaoItemAgropecuario: null,
      selecaoMunicipio: null,
      selecaoMunicipioLkp: [],
      selecaoSafra: null,
      selecaoSafraLkp: [],
      areaHa: "",
      nOperacao: "",
      vlOrcado: "",
      perAstec: "",
      vlAstec: "",
      vlLiberado: "",
      dataCredito: null,
      instituicaoFinanceiraLkp: [],
      selecaoInstituicaoFinanceira: null,
      loadingInstFinanceira: false,
      loadingClienteRural: false,
      loadingAgencia: false,
      loadingItemAgropecuario: false,
      instituicaoAgenciaLkp: [],
      selecaoAgencia: null,
      dataVencBoleto: null,
      cdPessoa: "",
      sqUsuario: "",
      cdProjeto: "30",
      sqProjetoVar: null,
      loading: true,
      loadingSalvar: false,
      submit: false,
      disabledCampos: false,
      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        prefix: "R$ ",
        masked: false
      },
      area: {
        decimal: ",",
        thousands: ".",
        suffix: " (ha)",
        precision: 2,
        masked: false
      },
      porcentagem: {
        decimal: ",",
        thousands: ".",
        suffix: " %",
        precision: 2,
        masked: false
      },
      requisito: { PROGRESSO: 0 },
      requisitoMenssagem: "",
      requisitoSugestao: [
        "Incluir o CPF/CNPJ do Cliente Rural",
        "Incluir a Data do Projeto",
        "Incluir a Linha de Crédito",
        "Incluir o Tipo de Projeto",
        "Incluir o Item Agropecuário"
      ]
    };
  },
  async created() {
    await this.buscarDados();
    if (this.$store.state.projetoAstec) {
      var projeto = this.$store.state.projetoAstec;
      this.statusProjeto = projeto.ST_PROJETO;
      this.cdProjeto = projeto.CD_PROJETO;
      this.sqProjetoVar = projeto.SQ_PROJETO_VAR;
      if (projeto.ST_PROJETO !== "ELABORADO") {
        this.disabledCampos = true;
      }
      this.preencherCampos(projeto);
    } else {
      this.statusProjeto = "ELABORADO";
    }
    this.$tools.fecharMenu();
  },
  validations: {
    selecaoCooperado: { required },
    selecaoClienteRural: { required },
    numeroProjeto: { required },
    dataProjeto: { required },
    selecaoLinhaCredito: { required },
    selecaoTipoProjeto: { required },
    selecaoItemAgropecuario: { required },
    selecaoModalidadeSeguro: { required },
    selecaoMunicipio: { required },
    selecaoSafra: { required },
    areaHa: { required, minValue: minValue(0.01) },
    vlOrcado: { required, minValue: minValue(1) },
    perAstec: { required },
    vlAstec: { required },
    selecaoInstituicaoFinanceira: { required },
    selecaoAgencia: { required }
  },
  watch: {
    vlOrcado() {
      this.calcularVlAstec();
    },
    perAstec() {
      this.calcularVlAstec();
    }
  },
  methods: {
    async buscarDados() {
      await this.getNomeRazaoUsuario();
      await this.buscarLkpCooperado();
      await this.verificarCooperado();
      await this.buscarLkpLinhaCredito();
      await this.buscarLkpTipoProjeto();
      await this.buscarLkpModalidadeSeguro();
      await this.buscarMunicipioUf();
      await this.buscarLkpSafra();
      await this.carregarClienteRural();
      this.loading = false;
    },

    state(param) {
      if (this.submit) {
        return !this.$v[param].$invalid;
      } else {
        return null;
      }
    },

    disableDatasFuturas(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },

    disableDatasPosteriores(date) {
      if (this.dataProjeto) {
        const today = new Date(this.dataProjeto);
        today.setHours(0, 0, 0, 0);
        return date < today;
      }
      return date;
    },

    async preencherCampos(projeto) {
      if (projeto) {
        this.selecaoCooperado = this.cooperadoLkp.find(
          el => el.value == projeto.CD_COOPERADO
        );
        await this.carregarClienteRural();
        this.selecaoClienteRural = this.encontrarClienteRuralDoProjeto(
          projeto
        );
        this.numeroProjeto = projeto.NR_PROJETO;
        this.dataProjeto = projeto.DT_PROJETO;
        this.selecaoLinhaCredito = this.linhaCreditoLkp.find(
          el => el.value == projeto.CD_LINHA_CREDITO
        );
        this.selecaoTipoProjeto = this.tipoProjetoLkp.find(
          el => el.name.split(" [")[0] === projeto.DS_TP_PROJETO
        );
        this.selecaoSafra = this.selecaoSafraLkp.find(
          el => el.name == projeto.CD_SAFRA
        );
        await this.carregarItemAgropecuario();
        this.selecaoItemAgropecuario = this.itemAgropecuarioLkp.find(
          el => el.name.split(" [")[0] == projeto.DS_ITEM_AGROPECUARIO
        );
        this.selecaoModalidadeSeguro = this.selecaoModalidadeSeguroLkp.find(
          el => el.value == projeto.CD_MODALIDADE_SEGURO
        );
        this.selecaoMunicipio = this.selecaoMunicipioLkp.find(
          el => el.value == projeto.SQ_REGIAO_PROJETO
        );
        this.areaHa = parseFloat(projeto.QT_AREA);
        this.nOperacao = projeto.CD_OPERACAO_CRED;
        this.vlOrcado = parseFloat(projeto.VL_ORCADO);

        this.vlAstec = parseFloat(projeto.VL_ASTEC);
        this.vlLiberado = parseFloat(projeto.VL_LIBERADO);
        this.dataCredito = projeto.DT_CREDITO_BCO;
        this.selecaoInstituicaoFinanceira = this.instituicaoFinanceiraLkp.find(
          el => el.value == projeto.CD_INSTITUICAO_FINANCEIRA
        );
        await this.carregarAgencia();
        this.selecaoAgencia = this.instituicaoAgenciaLkp.find(
          el => el.value == projeto.NR_AGENCIA
        );
        if (projeto.PER_ASTEC.length === 3) {
          this.perAstec = projeto.PER_ASTEC + "0";
        } else if (projeto.PER_ASTEC.length === 2) {
          this.perAstec = projeto.PER_ASTEC + "00";
        } else {
          this.perAstec = projeto.PER_ASTEC;
        }
        this.dataVencBoleto = projeto.DT_VENC_BOLETO;
      } else {
        console.error("Projeto não encontrado");
      }
    },

    encontrarClienteRuralDoProjeto(projeto) {
      if (!projeto || !Array.isArray(this.clienteRuralLkp)) return null;

      const valoresProjeto = this.extrairValoresProjeto(projeto);
      const codigoProjeto = `${
        projeto.SQ_CLIENTE ||
        projeto.CD_CLIENTE ||
        projeto.ID_CLIENTE ||
        projeto.ID ||
        projeto.CODIGO_CLIENTE ||
        ""
      }`;
      const cpfCnpjProjeto = this.normalizeCpfCnpj(
        projeto.NRCPFCNPJ ||
          projeto.NR_CPF_CNPJ ||
          projeto.CPF_CNPJ ||
          projeto.CPFCNPJ
      );
      const nomeProjeto = this.normalizeTexto(
        projeto.NMRAZAO ||
        projeto.NM_RAZAO ||
        projeto.DS_CLIENTE_RURAL ||
        projeto.CLIENTE_RURAL ||
        ""
      );

      return (
        this.clienteRuralLkp.find(el => this.extrairCodigoClienteRural(el) === codigoProjeto) ||
        this.clienteRuralLkp.find(el => `${el.value}` === `${projeto.SQ_CLIENTE}`) ||
        this.clienteRuralLkp.find(
          el => this.normalizeCpfCnpj(el.cpfCnpj) === cpfCnpjProjeto
        ) ||
        this.clienteRuralLkp.find(el => {
          const nomeLista = this.normalizeTexto(el.name || "");
          return nomeProjeto && nomeLista === nomeProjeto;
        }) ||
        this.clienteRuralLkp.find(el => {
          const nomeListaSemCodigo = this.normalizeTexto(
            (el.name || "").split(" [")[0]
          );
          return nomeProjeto && nomeListaSemCodigo === nomeProjeto;
        }) ||
        this.clienteRuralLkp.find(el =>
          this.projetoContemDadosDoCliente(valoresProjeto, el)
        ) ||
        null
      );
    },

    extrairValoresProjeto(projeto) {
      return Object.values(projeto)
        .filter(
          value =>
            value !== null &&
            value !== undefined &&
            ["string", "number"].includes(typeof value)
        )
        .map(value => `${value}`);
    },

    projetoContemDadosDoCliente(valoresProjeto, cliente) {
      const codigoCliente = `${cliente?.value || ""}`;
      const cpfCliente = this.normalizeCpfCnpj(cliente?.cpfCnpj || "");
      const nomeCompleto = this.normalizeTexto(cliente?.name || "");
      const nomeSemCodigo = this.normalizeTexto(
        (cliente?.name || "").split(" [")[0]
      );

      return valoresProjeto.some(valor => {
        const valorTexto = `${valor}`;
        const valorNormalizado = this.normalizeTexto(valorTexto);
        const valorCpf = this.normalizeCpfCnpj(valorTexto);

        return (
          (codigoCliente &&
            (valorTexto === codigoCliente ||
              valorTexto.includes(`[${codigoCliente}]`))) ||
          (cpfCliente && valorCpf === cpfCliente) ||
          (nomeCompleto && valorNormalizado === nomeCompleto) ||
          (nomeSemCodigo && valorNormalizado === nomeSemCodigo)
        );
      });
    },

    extrairCodigoClienteRural(cliente) {
      const match = (cliente?.name || "").match(/\[(\d+)\]/);
      return match ? match[1] : "";
    },

    normalizeTexto(value) {
      return (value || "")
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, " ")
        .trim()
        .toUpperCase();
    },

    normalizeCpfCnpj(value) {
      if (!value) return "";
      return value.replace(/\D/g, "");
    },

    calcularVlAstec() {
      if (parseFloat(this.perAstec.replace(",", ".")) > 100.0) {
        this.perAstec = "100";
      }
      if (this.vlOrcado && this.perAstec) {
        const percentualStr = this.perAstec.replace(",", ".");
        const percentual = parseFloat(percentualStr) / 100.0;
        this.vlAstec = percentual * this.vlOrcado;
      }
    },

    async getNomeRazaoUsuario() {
      try {
        const token = this.$store.state.access_token;
        const isErp = this.$store.state.user?.tipoUsuario === 'erp' || this.$store.state.me?.user_erp;
        const endpointMe = isErp ? "api/authErp/meErp" : "api/auth/me";
        const headerMe = { headers: { Authorization: `Bearer ${token}` } };
        const response = await this.$http.get(endpointMe, headerMe);
        this.cdPessoa = response.data.cd_pessoa;
        this.sqUsuario = response.data.sq_usuario;
        console.log("sqUsuario: ", this.sqUsuario);
      } catch (err) {
        console.log(err);
        this.logoutUser();
      }
    },

    async verificarCooperado() {
      if (this.cooperadoLkp.length > 0) {
        const cooperadoEncontrado = this.cooperadoLkp.find(
          cooperado => cooperado.value === this.cdPessoa
        );
        if (cooperadoEncontrado) {
          this.selecaoCooperado = cooperadoEncontrado;
          this.carregarInstFinanceira();
        } else {
          this.selecaoCooperado = null;
        }
      } else {
        this.selecaoCooperado = null;
      }
      return;
    },

    async carregarClienteRural() {
      if (this.selecaoCooperado) {
        this.clienteRuralLkp = [];
        this.selecaoClienteRural = null;
        this.loadingClienteRural = true;
        try {
          const response = await this.$http.get(
            "/api/astec/getLkpClienteRuralProjetos/" +
              this.selecaoCooperado.value
          );
          this.clienteRuralLkp = response.data.map(cliente => {
            return {
              name: cliente.DISPLAY,
              value: cliente.ID,
              cpfCnpj: cliente.NRCPFCNPJ
            };
          });
        } catch (err) {
          this.$tools.alerta(err.response.data.message, "error");
        }
        this.loadingClienteRural = false;
        this.carregarInstFinanceira();
      }
    },

    async carregarInstFinanceira() {
      this.instituicaoFinanceiraLkp = [];
      this.instituicaoAgenciaLkp = [];
      this.selecaoInstituicaoFinanceira = null;
      this.selecaoAgencia = null;
      this.loadingInstFinanceira = true;
      await this.buscarLkpInstituicaoFinanc(this.selecaoCooperado.value);
      this.loadingInstFinanceira = false;
    },

    async carregarAgencia() {
      if (this.selecaoInstituicaoFinanceira) {
        this.selecaoAgencia = null;
        this.loadingAgencia = true;
        try {
          const response = await this.$http.get(
            "/api/astec/getLkpAgencia/" +
              this.cdPessoa +
              "/" +
              this.selecaoInstituicaoFinanceira.value
          );
          this.instituicaoAgenciaLkp = response.data.map(nrAgencia => ({
            name: nrAgencia.DISPLAY,
            value: nrAgencia.ID
          }));
        } catch (err) {
          this.$tools.alerta(err.response.data.message, "error");
        }
        this.loadingAgencia = false;
      } else {
        this.instituicaoAgenciaLkp = [];
        this.selecaoAgencia = null;
      }
      return;
    },

    async carregarItemAgropecuario() {
      if (this.selecaoTipoProjeto) {
        this.perAstec = this.selecaoTipoProjeto.perAstec;
      }
      if (this.selecaoTipoProjeto && this.selecaoSafra) {
        this.selecaoItemAgropecuario = null;
        this.loadingItemAgropecuario = true;
        try {
          const response = await this.$http.get(
            "/api/astec/getLkpItemAgropecuario/" +
              this.selecaoTipoProjeto.value +
              "/" +
              this.selecaoSafra.epoca
          );
          this.itemAgropecuarioLkp = response.data.map(itemAgropecuario => ({
            name: itemAgropecuario.DISPLAY,
            value: itemAgropecuario.ID
          }));
        } catch (err) {
          this.$tools.alerta(err.response.data.message, "error");
        }
        this.loadingItemAgropecuario = false;
      } else {
        if (!this.selecaoTipoProjeto) {
          this.perAstec = "";
        }
        this.selecaoItemAgropecuario = null;
        this.itemAgropecuarioLkp = [];
      }
      return;
    },

    insertProjeto() {
      this.loadingSalvar = true;
      this.submit = true;

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loadingSalvar = false;
        return;
      }

      const obj = this.montarObjeto();
      this.$http
        .post("/api/astec/insertProjetos", obj)
        .then(response => {
          Swal.fire({
            icon: "success",
            title: "Sucesso",
            text: "Projeto salvo com sucesso!"
          });
          console.log(response);
          this.$router.push("/astec/projetos");
        })
        .catch(err => {
          if (err.response.data.message != "") {
            this.$tools.alerta(err.response.data.message, "error");
          } else {
            this.$tools.alerta("Erro ao salvar projeto", "error");
          }
        })
        .finally(() => {
          this.loadingSalvar = false;
        });
    },

    montarObjeto() {
      const dados = {
        sqUsuario: this.sqUsuario,
        cdCooperado: this.selecaoCooperado ? this.selecaoCooperado.value : null,
        sqCliente: this.selecaoClienteRural
          ? this.selecaoClienteRural.value
          : null,
        sqProjetoVar: this.sqProjetoVar,
        cdProjeto: this.cdProjeto,
        nrPlano: this.numeroProjeto ? this.numeroProjeto : null,
        dtProjeto: this.dataProjeto ? this.dataProjeto : null,
        sqLinhaCredito: this.selecaoLinhaCredito
          ? this.selecaoLinhaCredito.value
          : null,
        sqTpProjeto: this.selecaoTipoProjeto
          ? this.selecaoTipoProjeto.value
          : null,
        sqModalidadeSeguro: this.selecaoModalidadeSeguro
          ? this.selecaoModalidadeSeguro.value
          : null,
        cdItemAgropecuario: this.selecaoItemAgropecuario
          ? parseInt(this.selecaoItemAgropecuario.value)
          : null,
        sqRegiao: this.selecaoMunicipio ? this.selecaoMunicipio.value : null,
        cidade: this.selecaoMunicipio
          ? this.selecaoMunicipio.name.split(" - ")[0]
          : null,
        estado: this.selecaoMunicipio
          ? this.selecaoMunicipio.name.split(" - ")[1]
          : null,
        cdSafra: this.selecaoSafra ? this.selecaoSafra.name : null,
        qtArea: this.areaHa ? this.areaHa : null,
        cdOperacaoCred: this.nOperacao ? this.nOperacao : null,
        vlOrcado: this.vlOrcado ? this.vlOrcado : null,
        vlAstec: this.vlAstec ? this.vlAstec : 0,
        dtCredito: this.dataCredito ? this.dataCredito : null,
        cdBanco: this.selecaoInstituicaoFinanceira
          ? this.selecaoInstituicaoFinanceira.value
          : null,
        nrAgencia: this.selecaoAgencia ? this.selecaoAgencia.value : null,
        dtVctoFinanc: this.dataVencBoleto ? this.dataVencBoleto : null,
        cdInstituicaoFinanceira: this.selecaoInstituicaoFinanceira
          ? this.selecaoInstituicaoFinanceira.value
          : null
      };
      return dados;
    },

    voltar() {
      if (this.statusProjeto === "ELABORADO") {
        Swal.fire({
          icon: "warning",
          title: "ATENÇÃO",
          text:
            "Caso confirme, os dados cadastrados serão perdidos. Deseja sair sem salvar?",
          showCancelButton: true,
          confirmButtonText: "Sim",
          cancelButtonText: "Não"
        }).then(result => {
          if (result.isConfirmed) {
            this.$router.push("/astec/projetos");
          } else {
            console.log("O usuário optou por permanecer na página.");
          }
        });
      } else {
        this.$router.push("/astec/projetos");
      }
    }
  }
};
</script>

<style>
.is-valid .v-money {
  border-color: #34c38f !important;
}
.is-invalid .v-money {
  border-color: #f46a6a !important;
}
</style>
